import * as React from "react";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import ViewWhereToStayGuideButton from "./components/ViewWhereToStayGuideButton";
import { NeighborhoodCard } from "./components/NeighborhoodCard";
import { DestinationNeighborhoodsProps } from "./typings";
import { Neighborhood, TeNeighborhoodFlexModuleResult } from "typings/microserviceModels/te-neighborhood-flex-module";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { withStores } from "stores";
import { observer } from "mobx-react";

const DestinationNeighborhoods = withStores(
  "context",
  "flexModuleModelStore"
)(
  observer((props: DestinationNeighborhoodsProps) => {
    const { flexTemplateNode, flexModuleModelStore, context } = props;
    const { id, options } = flexTemplateNode;

    const model = flexModuleModelStore.getModel(id) as TeNeighborhoodFlexModuleResult | null;

    if (!model) {
      return null;
    }

    const { content } = model;
    const { formatText } = useLocalization();

    if (!content?.items?.length) {
      return null;
    }

    const { items, whereToStayUrl } = content;
    const neighborhoods = items.slice(0, 6);

    const neighborhoodsKeyHelper: ItemKeyHelper = new ItemKeyHelper("popular-neighborhood");

    const neighborhoodCards = (isDesktop: boolean) =>
      neighborhoods.map((neighborhood: Neighborhood, neighborhoodIndex: number) => (
        <UitkLayoutGridItem key={neighborhoodsKeyHelper.next()}>
          <NeighborhoodCard
            className="all-b-margin-three"
            neighborhood={neighborhood}
            position={neighborhoodIndex + 1}
            context={context}
            isDesktop={isDesktop}
            showFavorite
            isClickeable
            view={model.view}
          />
        </UitkLayoutGridItem>
      ));

    return (
      <div
        className="DestinationNeighborhoods all-y-padding-six uitk-cell all-cell-1-1"
        id={id}
        data-fm={options.fmId}
        data-fm-title-id={options.fmTitleId}
      >
        <UitkHeading level={3} size={600}>
          {context.searchContext.location.type === "neighborhood" ? (
            <UitkText>
              {formatText("destinationNeighborhood.neighborhood.title", context.searchContext.location.parent.name)}
            </UitkText>
          ) : (
            <UitkText>{formatText("destinationNeighborhood.title", context.searchContext.location.name)}</UitkText>
          )}
        </UitkHeading>

        <Viewport>
          <ViewSmall>
            <UitkLayoutGrid columns={1} space="one" className="destinationNeighborhoodsContainer all-t-margin-four">
              {neighborhoodCards(false)}
            </UitkLayoutGrid>
          </ViewSmall>

          <ViewLarge>
            <UitkLayoutGrid columns={3} space="three" className="destinationNeighborhoodsContainer all-t-margin-four">
              {neighborhoodCards(true)}
            </UitkLayoutGrid>
          </ViewLarge>
        </Viewport>

        {Boolean(whereToStayUrl) && <ViewWhereToStayGuideButton href={whereToStayUrl} />}
      </div>
    );
  })
);

export default DestinationNeighborhoods;
